import {
  CompanyTab,
  CompanyTabId,
  companyTabIds,
  INTERNAL_ONLY_WARNING_COPY,
} from './types.js';
import { EyeOffIcon } from '@contra/icons/icons';
import { Routes } from '@contra/routes';
import { ReactNode } from 'react';

const getTabIcon = (id: CompanyTabId): null | ReactNode => {
  if (id === 'people') {
    return <EyeOffIcon size={16} />;
  }

  return null;
};

const getTabLabel = (id: CompanyTabId): string => {
  switch (id) {
    case 'jobs':
      return 'Jobs';
    case 'lists':
      return `Lists`;
    case 'overview':
      return 'Overview';
    case 'people':
      return `Team`;
    case 'recommendations':
      return `Recommendations`;
    default:
      return '';
  }
};

const getTabTooltip = (id: CompanyTabId): null | string => {
  if (id === 'people') {
    return INTERNAL_ONLY_WARNING_COPY;
  }

  return null;
};

export const buildTabs = (
  visitorIsMember: boolean,
  showLists: boolean,
): CompanyTab[] =>
  companyTabIds
    .filter((id) => {
      return visitorIsMember || id !== 'people';
    })
    .filter((id) => {
      return showLists && id === 'lists' ? true : id !== 'lists';
    })
    .map((id) => ({
      count: null,
      icon: getTabIcon(id),
      id,
      isDisabled: false,
      label: getTabLabel(id),
      showUnreadIndicator: false,
      tooltip: getTabTooltip(id),
    }));

export const getTabIdFromView = (view: string | undefined): CompanyTabId => {
  const possibleValues: readonly string[] = companyTabIds;
  if (view && possibleValues.includes(view)) {
    return view as CompanyTabId;
  }

  return 'overview';
};

export const getCompanyRouteKeyFromTabId = (
  tabId: CompanyTabId,
): keyof Routes => {
  switch (tabId) {
    case 'jobs':
      return '/company/@slug/jobs';
    case 'lists':
      return '/company/@slug/lists';
    case 'overview':
      return '/company/@slug';
    case 'people':
      return '/company/@slug/people';
    case 'recommendations':
      return '/company/@slug/recommendations';
    default:
      return '/company/@slug';
  }
};
